<template lang="pug">
  .component-backoffice-invoice-list.row.column
    cards(:data="parsedReports")
    invoice-list-form(@filterInvoices="setSearch")
    base-list(:component="component", :dataLoader="dataLoader", :search="search", :searchRangeDataLoader="getReports")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

  import InvoiceListForm from 'components/structure/ui/filters/InvoiceListForm'
  import BaseList from "./BaseList";
  import HeaderColumns from "components/structure/ui/HeaderColumns";
  import Cards from "../../components/structure/Cards";

  export default {
    name: "BackofficeInvoiceList",
    components: {
      Cards,
      InvoiceListForm,
      BaseList,
      HeaderColumns
    },
    data() {
      return {
        component: require('src/components/backoffice/Invoice'),
        headers: ['', 'Internal ID / ID', 'Emission Date', 'Due date', 'Client Name', 'Tax', 'Total', 'Status', ''],
        search: null,
        reports: null
      }
    },
    methods: {
      setSearch(search) {
      console.log(search)
        this.search = search
      },
      dataLoader(callback, page, resultsPerPage, search) {
        if (search !== null && (typeof search.from !== 'undefined' || typeof search.to !== 'undefined')) {
          search.emission_from = search.from
          search.emission_to = search.to
        }

        KeplerBackofficeSdk.invoices.list(page, resultsPerPage, search).all((data) => {
          callback(data)
        })
      },
      getReports(range) {
        if (typeof range.start === 'undefined' || typeof range.end === 'undefined') {
          return
        }
        this.reports = null
        KeplerBackofficeSdk.reports.list(range).invoices((data) => {
          this.reports = data
        })
      }
    },
    computed: {
      parsedReports: function () {
        if (!this.reports) {
          return []
        }

        return [
          {
            title: "Total invoices",
            value: this.reports.invoice_number,
            color: '#6CB2B0'
          },
          {
            title: "Total billed cost",
            value: this.$priceWithcurrency(this.reports.total_billed_cost),
            color: '#E10D5A'
          },
          {
            title: "Total unpaid cost",
            value: this.$priceWithcurrency(this.reports.total_unpaid_cost),
            color: '#2BACC1'
          },
          {
            title: "Average cost",
            value: this.$priceWithcurrency(this.reports.average_invoice_cost)
          }
        ]
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// InvoiceList.vue?456665c6